import { observer } from 'mobx-react';
import { LoadingError } from '.././Types';
import FlashError from '../../../../../FlashMessage/FlashError';
import { NotTranslated, T } from '../../../../../../Translations';

interface Props {
  state: LoadingError;
}

function LoadingErrorView({ state }: Props) {
  return (
    <FlashError>
      <T kind="Error Loading." /> <NotTranslated text={state.error.kind} />
    </FlashError>
  );
}

export default observer(LoadingErrorView);
